module.exports = __webpack_public_path__ + "static/img/shu.cd984c19.png";